import { UserProfileDTO } from '@shared/clientTypes/DTOs/UserDTO';
import UniversitiesSection from './UniversitiesSection/UniversitiesSection';

interface GoalsTabProps {
  userId: string;
  userProfile?: Partial<UserProfileDTO>;
}

const GoalsTab = (props: GoalsTabProps) => {
  const { userId, userProfile } = props;

  return (
    <section className="flex flex-col gap-4">
      <UniversitiesSection userId={userId} userProfile={userProfile} />
    </section>
  );
};

export default GoalsTab;
